var indentation_default = {
  "indentZero": "rgwei",
  "indentOne": "McuQS",
  "indentTwo": "ztIdH",
  "indentThree": "hzMg0",
  "indentFour": "H4vyB",
  "indentFive": "eBimw",
  "indentSix": "huSle"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
